import { render } from "./accessControl.vue?vue&type=template&id=51935c4a&scoped=true"
import script from "./accessControl.vue?vue&type=script&lang=js"
export * from "./accessControl.vue?vue&type=script&lang=js"

import "./accessControl.vue?vue&type=style&index=0&id=51935c4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51935c4a"]])

export default __exports__